import type { FieldConfig, FormConfig } from '@/utils/form';
import {
  anredeId,
  bezugZumVnPrivatePerson,
  fuehrerscheindatum,
  geburtsdatum,
  hasAnBegleitetenFahrenTeilgenommen,
  hasPunkteInFlensburg,
  inHaeuslicherGemeinschaftMitVN,
  isHauptnutzer,
  vnIsFullAge,
} from '@/features/Sparten/shared/fieldConfigs/kfz/input/fahrerkreisFieldConfig';

const localAnredeId: FieldConfig = {
  ...anredeId,
  isRequired: true,
};

export const fahrerkreisNutzerSection: FormConfig = {
  formName: 'KfzFahrerkreisNutzer',
  fieldConfigs: [
    bezugZumVnPrivatePerson,
    localAnredeId,
    geburtsdatum,
    fuehrerscheindatum,
    vnIsFullAge,
    inHaeuslicherGemeinschaftMitVN,
    hasAnBegleitetenFahrenTeilgenommen,
    hasPunkteInFlensburg,
    isHauptnutzer,
  ],
};
